import { Colors } from './Colors.js';

export const GLOBAL_CSS = `
  *{box-sizing:border-box;margin:0;padding:0}
  body{font-family:system-ui,sans-serif;background:${Colors.dark};max-width:100%;overflow-x:hidden}
  @keyframes fadeIn      {from{opacity:0}to{opacity:1}}
  @keyframes slideUp     {from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  @keyframes slideInLeft {from{transform:translateX(-100%)}to{transform:translateX(0)}}
  @keyframes slideInDown {from{transform:translateY(-14px);opacity:0}to{transform:translateY(0);opacity:1}}
  @keyframes spin        {to{transform:rotate(360deg)}}
  @keyframes pulse-dot   {0%,100%{opacity:1}50%{opacity:0.3}}
  @keyframes scratch-move{0%{transform:rotate(0)}25%{transform:rotate(3deg)}50%{transform:rotate(0)}75%{transform:rotate(-3deg)}100%{transform:rotate(0)}}
  
  /* Animación nueva para el banner */
  @keyframes scrollLeft {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  .scroll-inner-animation {
    display: flex;
    flex-direction: row;
    gap: 12px;
    width: max-content;
    animation: scrollLeft 30s linear infinite;
  }
  .scroll-inner-animation:hover {
    animation-play-state: paused;
  }

  .logo-anim{animation:scratch-move 3s infinite ease-in-out}
  .splash-btn:hover{background:#f0e0a0!important;transform:translateY(-2px)}
  .card-hover:hover{transform:translateY(-4px);box-shadow:0 12px 32px rgba(0,0,0,0.14)!important;border-color:rgba(200,168,75,0.45)!important}
  .like-btn:hover{transform:scale(1.25)}
  .menu-row-hover:hover{background:rgba(255,255,255,0.04)}
  .sf-btn:hover{background:rgba(200,168,75,0.07)!important}
  .dv-scrollbar::-webkit-scrollbar{width:4px}
  .dv-scrollbar::-webkit-scrollbar-track{background:transparent}
  .dv-scrollbar::-webkit-scrollbar-thumb{background:rgba(200,168,75,0.3);border-radius:2px}
  .tooltip-c{position:absolute;top:calc(100%+7px);left:50%;transform:translateX(-50%);background:#1a1a2e;color:#fff;padding:5px 9px;border-radius:5px;font-size:0.68rem;white-space:nowrap;z-index:999}
  .tooltip-c::after{content:'';position:absolute;bottom:100%;left:50%;transform:translateX(-50%);border:4px solid transparent;border-bottom-color:#1a1a2e}
  .toggle-wrap{position:relative;width:36px;height:20px;flex-shrink:0}
  .toggle-wrap input{opacity:0;width:100%;height:100%;position:absolute;cursor:pointer;margin:0;z-index:2}
  .toggle-track{width:36px;height:20px;background:rgba(255,255,255,0.15);border-radius:10px;transition:background .2s;pointer-events:none}
  .toggle-wrap input:checked ~ .toggle-track{background:${Colors.gold}}
  .toggle-thumb{position:absolute;top:2px;left:2px;width:16px;height:16px;border-radius:50%;background:#fff;transition:transform .2s;pointer-events:none}
  .toggle-wrap input:checked ~ .toggle-thumb{transform:translateX(16px)}
  .page-dark{background:${Colors.dark};min-height:100vh;color:#fff}
  .section-label{padding:10px 20px 6px;font-size:10px;color:rgba(255,255,255,0.35);text-transform:uppercase;letter-spacing:0.5px;font-weight:500}
  .settings-item{display:flex;align-items:center;padding:13px 20px;gap:12px;cursor:pointer;border-bottom:0.5px solid rgba(255,255,255,0.05);transition:background .12s}
  .settings-item:hover{background:rgba(255,255,255,0.03)}
  .msg-in{background:#1a1a2e;color:rgba(255,255,255,0.85);align-self:flex-start;border-radius:14px 14px 14px 4px;max-width:75%;padding:9px 12px;font-size:12px;line-height:1.5}
  .msg-out{background:${Colors.gold};color:#0a0a0f;align-self:flex-end;border-radius:14px 14px 4px 14px;max-width:75%;padding:9px 12px;font-size:12px;line-height:1.5}
  .msg-system{align-self:center;font-size:10px;color:rgba(255,255,255,0.3);background:rgba(255,255,255,0.05);padding:4px 12px;border-radius:20px}
  input[type=range]{accent-color:${Colors.gold};width:100%;cursor:pointer}
  .dv-input::placeholder{color:rgba(0,0,0,0.38)}
`;